export const checkListParams = <T>(list?: T[]): T[] | undefined => (list?.length ? list : undefined);
